export default __webpack_public_path__ + "static/media/forestly-expl-dissect-03_DE.6056c96c.png";